import axios from "axios";

import { baseApiUrl } from "../General/Constants";

import localStorageProvider from "../Providers/LocalStorageProvider";

export default () => {
  return {
    login: async (params: any) => {
      const url = `${baseApiUrl}/customer/public/auth/login`;

      const { username, password } = params;

      try {
        const loginResponse = await axios.post(url, {
          email: username,
          password,
        });

        //console.log("loginResponse.data", loginResponse);

        localStorageProvider.setItem("token", loginResponse.data.access_token);
        localStorageProvider.setItem(
          "user",
          JSON.stringify(loginResponse.data.user)
        );
      } catch (error) {
        //console.log("error.response", error);

        if (error && error.response && error.response.data.message) {
          throw error.response.data.message;
        }
        throw "An error has occured!";
      }
    },
    logout: async () => {
      localStorageProvider.removeItem("token");
      localStorageProvider.removeItem("user");
    },
    checkAuth: async () => {
      const token = localStorageProvider.getItem("token");
      if (!token) {
        throw {};
      }
    },
    checkError: (error: any) => Promise.resolve(),
    getPermissions: (params: any) => Promise.resolve(),
  };
};
